var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 1594,
    cy: 1115,
    r: 530,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 1594,
    cy: 1122,
    r: 972,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 1594,
    cy: 1115,
    r: 751,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1670.27 481.242C1696.22 529.605 1693.13 652.283 1659.6 660.926C1646.23 664.373 1617.74 655.93 1588.74 638.454L1606.94 767.209H1499.48L1536.47 594.774C1515.84 570.556 1501.88 540.877 1504.21 507.622C1510.93 411.799 1644.32 432.879 1670.27 481.242Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1528.22 616.347C1514.73 556.342 1476.31 515.439 1482.17 488.62C1486.09 470.74 1496.51 459.621 1513.45 455.263C1522.22 419.816 1550.48 404.738 1598.24 410.032C1669.87 417.971 1713.6 447.721 1694.71 513.185C1677.36 513.185 1656.4 506.907 1627.43 517.662C1618.24 521.075 1611.66 531.657 1607.7 549.409H1594.61C1581.9 528.342 1569.37 520.601 1557.02 526.184C1544.67 531.768 1541.86 545.332 1548.6 566.874L1542.15 616.347H1528.22Z",
    fill: "#181658"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1463.66 1138.85L1625.99 1708.52L1744.43 2128.4H1830.82L1704.96 1138.85H1463.66Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1420.24 1138.85C1416.49 1432.47 1403.68 1592.61 1399.74 1619.29C1395.8 1645.97 1336.19 1815.67 1220.91 2128.4H1310.4C1457.16 1828.39 1539.08 1658.68 1556.17 1619.29C1573.26 1579.89 1626.01 1419.75 1705.45 1138.85H1420.24Z",
    fill: "#393F82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1294.89 1085.21L1388.46 1085.57C1330.68 1272.08 1299.49 1371.04 1294.89 1382.46C1284.53 1408.13 1306.45 1447.24 1315.83 1468.25C1285.29 1481.92 1288.55 1431.31 1250.02 1449.23C1214.86 1465.59 1188.11 1495.23 1147.49 1470.17C1142.5 1467.08 1137.02 1455.48 1150.25 1446.41C1183.19 1423.82 1230.67 1384.29 1237.08 1371.27C1245.83 1353.53 1265.1 1258.17 1294.89 1085.21ZM1857.89 1067.75L1984.73 1191.49C2021.64 1207.24 2051.87 1224.62 2075.45 1243.64C2080.75 1250.04 2086.52 1262.29 2061.58 1256.81C2036.64 1251.32 2010.16 1246.68 2005.47 1254.79C2000.78 1262.9 2014.59 1275.33 2005.93 1285.95C2000.15 1293.02 1980.73 1270.51 1947.66 1218.41L1815.76 1140.65L1857.89 1067.75Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1560.8 692.576L1599.52 685.935C1666.18 852.459 1782.56 1003.77 1948.67 1139.86L1823.15 1292.35C1657.07 1098.57 1554.69 898.648 1560.8 692.576Z",
    fill: "#E87613"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1392.02 1179.15H1736.79C1656.92 984.933 1616.98 819.949 1616.98 684.197L1512.97 668.701C1431.24 800.157 1408.16 962.005 1392.02 1179.15Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1517.6 668.701C1525.73 668.981 1538.1 669.485 1554.72 670.213L1579.85 742.03C1582.51 829.593 1598.03 1006.05 1626.42 1271.41L1400.42 1271.41C1401.01 1289.74 1401.98 1308.24 1403.35 1326.91H1235.3C1260.44 1043.32 1352.23 823.913 1510.69 668.701L1510.77 668.777L1510.81 668.701H1517.6Z",
    fill: "#FFA434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1463.66 1273.18L1400.48 1273.17C1397.71 1190.98 1402.67 1112.23 1415.35 1036.92C1421.78 1151.16 1437.89 1229.91 1463.66 1273.18Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1450.72 1134.37L1562.17 1082.57V1134.37H1450.72Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotential);
export default __webpack_public_path__ + "static/media/potential.4377e01d9c402cb04873ea42ffef3ceb.svg";
export { ForwardRef as ReactComponent };